"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnOfferYouCantRefuse = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const ProjectCard_1 = require("../ProjectCard");
const Turmoil_1 = require("../../turmoil/Turmoil");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
class AnOfferYouCantRefuse extends ProjectCard_1.ProjectCard {
    constructor() {
        super({
            name: CardName_1.CardName.AN_OFFER_YOU_CANT_REFUSE,
            cardType: CardType_1.CardType.EVENT,
            cost: 5,
            metadata: {
                description: 'Exchange a NON-NEUTRAL NON-LEADER delegate with one of your own from the reserve. You may then move your delegate to another party.',
                cardNumber: 'M62',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().delegates(1).any.asterix().nbsp().plus().delegates(1);
                }),
            },
        });
    }
    ;
    hasReplacebleDelegate(player, party) {
        return player.game.getPlayers().filter((p) => p.id !== player.id).some((player) => party.getDelegates(player.id) > 1 || (party.getDelegates(player.id) === 1 && party.partyLeader !== player.id));
    }
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const hasDelegate = turmoil.hasAvailableDelegates(player.id) || turmoil.lobby.has(player.id);
        if (!hasDelegate)
            return false;
        return turmoil.parties.some((party) => this.hasReplacebleDelegate(player, party));
    }
    moveToAnotherParty(game, from, delegate) {
        const orOptions = new OrOptions_1.OrOptions();
        const turmoil = Turmoil_1.Turmoil.getTurmoil(game);
        turmoil.parties.forEach((party) => {
            if (party.name === from) {
                orOptions.options.push(new SelectOption_1.SelectOption('Do not move', '', () => {
                    return undefined;
                }));
            }
            else {
                orOptions.options.push(new SelectOption_1.SelectOption(party.name, 'Select', () => {
                    turmoil.removeDelegateFromParty(delegate, from, game);
                    turmoil.sendDelegateToParty(delegate, party.name, game, 'reserve');
                    return undefined;
                }));
            }
        });
        return orOptions;
    }
    play(player) {
        const game = player.game;
        const turmoil = Turmoil_1.Turmoil.getTurmoil(game);
        const orOptions = new OrOptions_1.OrOptions();
        turmoil.parties.forEach((party) => {
            if (!this.hasReplacebleDelegate(player, party))
                return;
            game.getPlayers().filter((p) => p.id !== player.id).forEach((opponent) => {
                if (party.getDelegates(opponent.id) > 1 || (party.getDelegates(opponent.id) === 1 && party.partyLeader !== opponent.id)) {
                    const option = new SelectOption_1.SelectOption(`${party.name} / ${opponent.name}`, 'Select', () => {
                        const source = turmoil.hasAvailableDelegates(player.id) ? 'reserve' : 'lobby';
                        turmoil.replaceDelegateFromParty(opponent.id, player.id, source, party.name, game);
                        turmoil.checkDominantParty(party);
                        return this.moveToAnotherParty(game, party.name, player.id);
                    });
                    orOptions.options.push(option);
                }
            });
        });
        return orOptions;
    }
}
exports.AnOfferYouCantRefuse = AnOfferYouCantRefuse;
//# sourceMappingURL=AnOfferYouCantRefuse.js.map